function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h240v240H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.062 83.9h148.696v44.721H40.062v-44.72zm55.193 35.5l-9.201-23.425h-4.455L72.397 119.4h3.386c.367 0 .678-.103.931-.308.254-.205.424-.432.51-.68l1.75-4.78h9.704l1.75 4.78c.108.28.283.515.526.704.243.19.554.284.932.284h3.37zm-15.163-8.845l2.851-7.76c.14-.356.284-.772.43-1.247.146-.476.294-.989.445-1.54.151.551.305 1.062.462 1.532.157.47.3.877.43 1.223l2.85 7.792h-7.468zm22.98.6h3.273c1.523 0 2.851-.19 3.985-.568 1.134-.378 2.08-.907 2.835-1.587a6.471 6.471 0 001.701-2.439c.378-.945.567-1.984.567-3.118 0-1.09-.178-2.095-.534-3.013a6.027 6.027 0 00-1.653-2.365c-.745-.66-1.69-1.172-2.835-1.54-1.144-.367-2.5-.55-4.066-.55h-7.63V119.4h4.358v-8.246zm0-3.403v-8.408h3.273c.8 0 1.496.095 2.09.284.594.189 1.085.462 1.474.818.389.356.68.788.875 1.296.194.508.292 1.075.292 1.701 0 .659-.098 1.255-.292 1.79a3.52 3.52 0 01-.875 1.36c-.389.374-.88.66-1.474.86-.594.2-1.29.3-2.09.3h-3.272zm21.15 2.495h1.864c.432 0 .758.06.98.178.221.119.424.319.607.6l4.925 7.5c.184.281.408.497.672.648.265.151.586.227.964.227h3.92l-5.864-8.65c-.4-.584-.874-1.032-1.425-1.345a8.492 8.492 0 002.195-1.037 6.77 6.77 0 001.62-1.507 6.47 6.47 0 001.004-1.911 7.074 7.074 0 00.349-2.236c0-.994-.17-1.903-.51-2.73a5.347 5.347 0 00-1.605-2.13c-.729-.594-1.663-1.056-2.802-1.385-1.14-.33-2.508-.494-4.107-.494h-7.144V119.4h4.358v-9.153zm0-3.127v-7.776h2.787c1.61 0 2.805.319 3.588.956.784.637 1.175 1.55 1.175 2.738 0 .594-.097 1.14-.292 1.636a3.416 3.416 0 01-.883 1.288c-.394.362-.896.645-1.506.85-.61.206-1.326.308-2.147.308h-2.721zm22.528 12.28V95.975h-4.374V119.4h4.374zm10.523-3.596v-19.83h-4.358V119.4h13.737v-3.596h-9.38z",
  fill: "#E65100"
}), /*#__PURE__*/React.createElement("path", {
  d: "M88.07 45.888h64.053-64.054zm0 0h64.053-64.054zM207 208.354h3l-3 3v-3zm0 0V61.54c0-6.987-5.665-12.652-12.652-12.652h-9.855v-3h9.855c8.644 0 15.652 7.008 15.652 15.652v149.814H30V61.54c0-8.644 7.008-15.652 15.652-15.652h9.65v3h-9.65C38.665 48.888 33 54.553 33 61.54v146.814h174zm-174 0v3l-3-3h3zm0 0v3l-3-3h3zm0 0h174V61.54c0-6.987-5.665-12.652-12.652-12.652h-9.855v-3h9.855c8.644 0 15.652 7.008 15.652 15.652v149.814H30V61.54c0-8.644 7.008-15.652 15.652-15.652h9.65v3h-9.65C38.665 48.888 33 54.553 33 61.54v146.814zm174 0h3l-3 3v-3z",
  fill: "#371447",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#371447",
  strokeWidth: 3,
  d: "M39.9 83.8v109.565h159.876v-48.773"
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.366 68.248v-3a5.944 5.944 0 01-5.944-5.944v-22.36a5.944 5.944 0 0111.889 0v5.022h3v-5.022a8.944 8.944 0 00-17.889 0v22.36a8.944 8.944 0 008.944 8.944zm0 0v-3a5.944 5.944 0 01-5.944-5.944v-22.36a5.944 5.944 0 0111.889 0v5.022h3v-5.022a8.944 8.944 0 00-17.889 0v22.36a8.944 8.944 0 008.944 8.944zm99.578 0v-3A5.944 5.944 0 01165 59.304v-22.36a5.944 5.944 0 1111.888 0v5.022h3v-5.022a8.944 8.944 0 00-17.888 0v22.36a8.944 8.944 0 008.944 8.944zm0-3A5.944 5.944 0 01165 59.304v-22.36a5.944 5.944 0 1111.888 0v5.022h3v-5.022a8.944 8.944 0 00-17.888 0v22.36a8.944 8.944 0 008.944 8.944v-3z",
  fill: "#371447",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.672 200.733h157.024",
  stroke: "#371447",
  strokeWidth: 3,
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("path", {
  d: "M92.231 177.739h8.966v-25.796c0-1 .03-2.05.092-3.152l-6.365 5.325a2.257 2.257 0 01-.81.459 2.846 2.846 0 01-.812.122c-.408 0-.78-.086-1.117-.26-.336-.173-.586-.372-.75-.597l-2.386-3.274 13.495-11.475h6.211v38.648h7.956v5.661h-24.48v-5.661zm57.528-35.374c0 1.082-.341 1.959-1.025 2.632-.683.673-1.82 1.01-3.412 1.01h-12.178l-1.592 9.241c2-.408 3.825-.612 5.478-.612 2.325 0 4.37.347 6.135 1.04 1.765.694 3.249 1.653 4.452 2.877a12.067 12.067 0 012.724 4.3c.612 1.641.918 3.411.918 5.308 0 2.346-.413 4.488-1.24 6.426-.826 1.938-1.973 3.596-3.442 4.973-1.469 1.377-3.208 2.443-5.217 3.197-2.01.755-4.198 1.133-6.564 1.133-1.387 0-2.703-.143-3.947-.429a19.585 19.585 0 01-6.534-2.8 19.15 19.15 0 01-2.493-1.973l2.325-3.213c.49-.694 1.143-1.04 1.959-1.04.51 0 1.025.162 1.545.489.52.326 1.127.683 1.82 1.07.694.388 1.5.745 2.418 1.072.918.326 2.03.49 3.335.49 1.388 0 2.612-.225 3.672-.674 1.061-.449 1.943-1.076 2.647-1.882.704-.806 1.234-1.764 1.591-2.876.358-1.112.536-2.32.536-3.626 0-2.407-.699-4.29-2.096-5.646-1.398-1.357-3.453-2.035-6.166-2.035-2.142 0-4.294.388-6.457 1.163l-4.712-1.346 3.672-21.482h21.848v3.213z",
  fill: "#E65100"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.45 62.623h3c0 6.273 5.085 11.357 11.357 11.357 6.273 0 11.358-5.084 11.358-11.357a11.35 11.35 0 00-5.692-9.845l1.499-2.6a14.35 14.35 0 017.193 12.445c0 7.93-6.428 14.357-14.358 14.357-7.929 0-14.357-6.428-14.357-14.357zm98.385 0h3c0 6.273 5.085 11.357 11.358 11.357 6.272 0 11.357-5.084 11.357-11.357a11.35 11.35 0 00-5.692-9.845l1.499-2.6a14.35 14.35 0 017.193 12.445c0 7.93-6.428 14.357-14.357 14.357-7.93 0-14.358-6.428-14.358-14.357z",
  fill: "#371447",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#371447"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -380.463 169.945)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -375.463 188.605)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -370.463 207.265)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -365.463 225.926)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -360.463 244.586)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -355.463 263.246)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -350.463 281.906)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -345.463 300.567)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -340.463 319.227)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -335.463 337.887)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -330.463 356.547)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -325.463 375.208)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -320.463 393.868)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -315.463 412.528)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -310.463 431.188)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -305.463 449.849)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -300.463 468.509)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -295.963 485.303)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 11,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 17,
  r: 1
}))), /*#__PURE__*/React.createElement("path", {
  fill: "#371447",
  d: "M89 46h64v3H89z"
}));

function SvgTaxPaymentsXl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgTaxPaymentsXl;